const H5pExternalDispatcher = () => {
    document.addEventListener("DOMContentLoaded", function () {

        if (window.H5P && H5P.externalDispatcher) {
            H5P.externalDispatcher.on('xAPI', function (event) {
                const stmt = event.data.statement;
                if ( !stmt.result){
                    return;
                }

                let scaled = stmt.result.score.scaled;

                if(1 !== scaled){
                    return;
                }

                const nextLink      =  document.getElementById('ld-navigation__next-link');
                if (!nextLink){
                    return;
                }
                const postId = nextLink.dataset.id;
                const courseId = nextLink.dataset.courseId;

                if (!postId){
                    return;
                }


                if (/subContentId=/.test(stmt.object.id)) return;
                const idMatch = stmt.object.id.match(/id=(\d+)/);
                const contentId = idMatch ? idMatch[1] : null;

                jQuery.ajax({
                    url: rcData.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'h5p_status',
                        postId: postId,
                        contentId: contentId,
                        courseId: courseId,
                        _ajax_nonce: rcData.nonce
                    },
                    success: function (response) {

                        if (!response.success || !response.data.h5pAdditionalClass) {
                            return;
                        }

                        const nextLink = document.getElementById('ld-navigation__next-link');
                        if (!nextLink) return;
                        nextLink.classList.remove('h5p-passed', 'h5p-not-passed');
                        nextLink.classList.add(response.data.h5pAdditionalClass);
                    }

                });

            });
        }

    });
};

export default H5pExternalDispatcher;
